import { Doc, generateToDocFn } from '@dadohr/shared/domainTypes/document';
import { OktaIntegrationConfig } from '@dadohr/shared/domainTypes/integrations/okta';
import { FS } from '@dadohr/shared/versions';
import {
  store,
  useMappedLoadingValue
} from '../../../../../../services/firebase';
import {
  createDocumentListenerGetter,
  useDocumentListener
} from '../../../../../../services/firecache/documentListener';
import { now } from '../../../../../../services/time';

export const toOktaConfigDoc = generateToDocFn<OktaIntegrationConfig>();

const COLLECTION = FS.oktaIntegrationConfig;
const collection = () => store().collection(COLLECTION);

export const oktaConfigStore = createDocumentListenerGetter(
  (orgId) => collection().doc(orgId),
  toOktaConfigDoc
);

export const useOktaConfig = (orgId: string, userId: string) => {
  return useMappedLoadingValue(
    useDocumentListener(oktaConfigStore(orgId)),
    (d) => {
      if (!d) {
        const n = now();
        const newConfig: Doc<OktaIntegrationConfig> = {
          id: orgId,
          collection: COLLECTION,
          data: {
            orgId,
            active: false,
            createdAt: n,
            createdBy: userId,
            editedAt: n,
            editedBy: userId,

            // idpSsoUrl: '',
            // idpIssuer: '',
            // x509Certificate: '',

            idpMetadata: ''
          }
        };
        return newConfig;
      }
      return d;
    }
  );
};

export const removeOktaConfig = (orgId: string) => {
  // TODO cleanup up SSO settings on org
  return collection().doc(orgId).delete();
};
